<div #messagesList [scrollTop]="scrollTop" class="messages-list">
  @for (message of messages; track message) {
    <div>
      <app-message-detail
        [message]="message"
        (likeRate)="onLikePress($event)"
        (dislikeRate)="onDislikePress($event)"
      ></app-message-detail>
    </div>
  }
</div>
